import { utilityJWEUrl } from './endpoints';
export const utilityJWECacheKey = ({ accountId, accountIdType }) => [utilityJWEUrl, { accountId, accountIdType }];
